import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { RouterModule } from '@angular/router';

import { BannerComponent } from './banner.component';

@NgModule({
  imports: [
    CommonModule,
    RouterModule
  ],
  declarations: [
    BannerComponent,
  ],
  exports: [
    BannerComponent
  ]
})

export class BannerModule { }



// WEBPACK FOOTER //
// ./src/app/modules/banner-editor/stage/banner/banner.module.ts